import React, { useContext } from 'react';
import ColorsContext from './ColorsContext';

export default function ISLTable(props) {
  const levelColorsContext = useContext(ColorsContext).levelColors;
  const levelColors = props.colors ? props.colors : levelColorsContext;

  return (
    <table className="tableLegend-container">
      <caption>
        Shading indicates index severity levels with corresponding percentile ranges:
      </caption>   
      <tbody>
        <tr>
          <td className="tableLegend-value-container" style={{"backgroundColor":"white"}}>Index Severity Level</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[0]}}>Level 0</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[1]}}>Level 1</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[2]}}>Level 2</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[3]}}>Level 3</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[4], "color":"white"}}>Level 4</td>
        </tr>
        <tr>
          <td className="tableLegend-value-container" style={{"backgroundColor":"white"}}>Percentile Range</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[0]}}>&gt;30</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[1]}}>30 to &gt;20</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[2]}}>20 to &gt;10</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[3]}}>10 to &gt;2</td>
          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[4], "color":"white"}}>&le;2</td>
        </tr>
      </tbody>
    </table>
  );
}